
import { Time } from '@/model';
import Vue from 'vue';

export default Vue.extend({

  props: {
    value: { type: Number as () => Time | undefined, required: false },
    label: { type: String, default: 'Pick a Date' },
    clearable: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
  },

  data() {
    return {
      edit: false,
      editValue: undefined as string | undefined,
    };
  },

  watch: {
    value: {
      handler(value) {
        this.editValue = value ? Time.asDateString(value) : undefined;
      },
      immediate: true,
    },

  },

  methods: {
    input() {
      this.edit = false;
      this.$emit('input', this.editValue ? Time.parse(this.editValue) : undefined);
    },
    clear() {
      this.editValue = undefined;
      this.input();
    },
  },
});

